// LoginPage.jsx

import React, { useState } from 'react';
import { Form, Input, Button, message, App } from 'antd';
import axios from '../config/axiosInstance';
import { useAuth } from '../context/AuthContext';
import { useNavigate } from 'react-router-dom';

import '../styles/Login26.css';

const LoginPage = () => {
  const [loading, setLoading] = useState(false);
  const { login } = useAuth();
  const navigate = useNavigate();

  const onFinish = async (values) => {
    setLoading(true);
    try {
      const response = await axios.post('/auth/login', values);
      const { token } = response.data;

      if (token) {
        login(token);
        message.success('Login successful!');
        navigate('/');
      } else {
        message.error('Login failed. No token received.');
      }
    } catch (error) {
      console.error(
          'Login error:',
          error?.response ? error.response.data : error?.message
      );
      message.error('Login failed. Please try again.');
    } finally {
      setLoading(false);
    }
  };

  return (
      <App>
        <div className="login26-page">
          <div className="login26-shell">
            <div className="login26-hero">
              <div className="login26-blob login26-blob1" />
              <div className="login26-blob login26-blob2" />

              <div className="login26-inner">
                <div className="login26-left">
                  <h1 className="login26-leftTitle">Dsync</h1>
                </div>

                <section className="login26-card">
                  <div className="login26-header">
                    <div className="login26-brandRow">
                      <img
                          src="/default_appicon.svg"
                          alt="Logo"
                          className="login26-logo"
                      />
                    </div>

                    <h2 className="login26-title">Sign in</h2>
                    <p className="login26-subtitle">Please sign in to continue</p>
                  </div>

                  <Form
                      name="login"
                      onFinish={onFinish}
                      initialValues={{ remember: true }}
                      layout="vertical"
                      className="login26-form"
                      requiredMark={false}
                  >
                    <Form.Item
                        label={<span className="login26-label">Username</span>}
                        name="username"
                        rules={[
                          { required: true, message: 'Please input your username!' },
                        ]}
                        style={{ marginBottom: 0 }}
                    >
                      <Input
                          placeholder="username"
                          autoComplete="username"
                          className="login26-inputFixed"
                      />
                    </Form.Item>

                    <Form.Item
                        label={<span className="login26-label">Password</span>}
                        name="password"
                        rules={[
                          { required: true, message: 'Please input your password!' },
                        ]}
                        style={{ marginBottom: 0 }}
                    >
                      {/* AntD Password input needs wrapper + inner input styling */}
                      <Input.Password
                          placeholder="••••••••"
                          autoComplete="current-password"
                          className="login26-passwordFixedWrapper"
                          styles={{
                            input: { backgroundColor: '#ffffff', color: '#111827' },
                          }}
                      />
                    </Form.Item>

                    <Button
                        type="primary"
                        htmlType="submit"
                        loading={loading}
                        className="login26-submit"
                        block
                    >
                      {loading ? 'Loading...' : 'Sign in'}
                    </Button>
                  </Form>

                  <div className="login26-footer">
                    © {new Date().getFullYear()} LambdaLogic
                  </div>
                </section>
              </div>
            </div>
          </div>
        </div>
      </App>
  );
};

export default LoginPage;